// extracted by mini-css-extract-plugin
export default {"activeQuestion":"ActiveQuestion_activeQuestion__6aBnb"};